export default {
  state: {
    name: '',
    discount: 0,
    isWholesale: false,
    rfc: '',
    fiscalRegimeId: null,
    contactInfo: [],
    zipCode: '',
  },
  mutations: {
    SET_NAME(state, name) {
      state.name = name;
    },
    SET_DISCOUNT(state, discount) {
      state.discount = discount;
    },
    SET_IS_WHOLESALE(state, isWholesale) {
      state.isWholesale = isWholesale;
    },
    SET_RFC(state, rfc) {
      state.rfc = rfc;
    },
    SET_FISCAL_REGIME_ID(state, fiscalRegimeId) {
      state.fiscalRegimeId = fiscalRegimeId;
    },
    SET_CONTACT_INFO(state, contactInfo) {
      state.contactInfo = contactInfo;
    },
    SET_ZIP_CODE(state, zipCode) {
      state.zipCode = zipCode;
    },
  },
  actions: {
    saveUncommittedChanges({ commit }, payload) {
      commit('SET_NAME', payload.name);
      commit('SET_DISCOUNT', payload.discount);
      commit('SET_IS_WHOLESALE', payload.isWholesale);
      commit('SET_RFC', payload.rfc);
      commit('SET_FISCAL_REGIME_ID', payload.fiscalRegimeId);
      commit('SET_CONTACT_INFO', payload.contactInfo);
      commit('SET_ZIP_CODE', payload.zipCode);
    },
    clearUncommittedChanges({ commit }) {
      commit('SET_NAME', '');
      commit('SET_DISCOUNT', 0);
      commit('SET_IS_WHOLESALE', false);
      commit('SET_RFC', '');
      commit('SET_FISCAL_REGIME_ID', null);
      commit('SET_CONTACT_INFO', []);
      commit('SET_ZIP_CODE', '');
    },
  },
  getters: {
    getUncommittedChanges(state) {
      return {
        name: state.name,
        discount: state.discount,
        isWholesale: state.isWholesale,
        rfc: state.rfc,
        fiscalRegimeId: state.fiscalRegimeId,
        contactInfo: state.contactInfo,
        zipCode: state.zipCode,
      };
    },
  },
};
